import APIClient from '@/shared/http/clients/api'

const APIPci = process.env.APIBaseURLPci
const resourceName = 'AnaliseTecItemDetalhe'

const Update = (data = {}, config = {}) => APIClient.put(`${APIPci}/${resourceName}`, data, config)
const GetLastHistoric = (tecAnalisysId, data = {}, config = {}) => APIClient.get(`${APIPci}/${resourceName}/analiseTec/${tecAnalisysId}`, data, config)

export default {
  Update,
  GetLastHistoric
}



// WEBPACK FOOTER //
// ./src/shared/http/repositories/pci/tecanalysisitemdetail.js